import React, { useEffect, useState } from 'react';
import { LogoMark } from '@/components/Logo';

// Branded launch splash for the installed app (and cold web loads).
// Shows briefly on mount, then fades out.
export const SplashScreen = () => {
  const [hidden, setHidden] = useState(false);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setHidden(true), 1150);
    const t2 = setTimeout(() => setGone(true), 1650);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  if (gone) return null;

  return (
    <div
      aria-hidden="true"
      data-testid="splash-screen"
      style={{
        position: 'fixed', inset: 0, zIndex: 400,
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 18,
        background: 'linear-gradient(160deg, #0FA3A8 0%, #0D3B4E 100%)',
        opacity: hidden ? 0 : 1,
        transition: 'opacity 480ms ease',
        pointerEvents: hidden ? 'none' : 'auto',
      }}
    >
      <div style={{ animation: 'ss-pop 520ms cubic-bezier(0.2,0.8,0.2,1)' }}>
        <div style={{ background: '#FFFFFF', borderRadius: 28, padding: 18, boxShadow: '0 18px 50px rgba(0,0,0,0.28)' }}>
          <LogoMark size={104} />
        </div>
      </div>
      <div style={{ fontFamily: 'var(--font-heading)', fontWeight: 800, fontSize: 30, letterSpacing: '-0.02em', color: '#FFFFFF' }}>
        KilalaRide
      </div>
      <div style={{ fontFamily: 'var(--font-secondary)', fontWeight: 500, fontSize: 14, color: '#CFEFF2' }}>
        Safe rides. Safer PH.
      </div>
    </div>
  );
};
